var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"standard-video-player"}},[_c('video',{ref:"video",staticClass:"video-js vjs-default-skin vjs-16-9 vjs-big-play-centered",attrs:{"autoplay":_vm.autoplay,"controls":""}},[_c('source',{attrs:{"src":_vm.sourceUrl,"type":_vm.type}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }